import { useEffect, useState } from 'react';

import { formatMarketingSenderPostalAddress } from '../settings/unsubscribe/templates';
import { getMarketingSendersRawList } from '../utils/marketingSenderOptions';
import { listSenders } from 'services/SenderService';
import { getLiteral } from 'utils/getLiteral';

const buildEmptyFooterPreview = () => ({
    senderName: '',
    senderAddress: '',
    footerHere: getLiteral('label_marketing_campaigns_unsubscribe_here'),
    linkHref: '#',
});

const findDefaultSender = (raw) =>
    raw.find((sender) => Boolean(sender.isDefault ?? sender.default ?? sender.defaultSender)) ??
    raw[0];

const buildFooterPreviewFromSender = (defaultSender) => ({
    senderName: defaultSender?.name ? String(defaultSender.name).trim() : '',
    senderAddress: formatMarketingSenderPostalAddress(defaultSender),
    footerHere: getLiteral('label_marketing_campaigns_unsubscribe_here'),
    linkHref: '#',
});

/**
 * Resolves footer preview values from the default marketing sender.
 * Used in template list thumbnails, preview modals, and editors.
 */
export default function useDefaultMarketingFooterPreview(isOpen = false) {
    const [footerPreview, setFooterPreview] = useState(buildEmptyFooterPreview);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        let cancelled = false;

        listSenders()
            .then((data) => {
                if (cancelled) {
                    return;
                }
                const raw = getMarketingSendersRawList(data);
                const defaultSender = findDefaultSender(raw);
                setFooterPreview(buildFooterPreviewFromSender(defaultSender));
            })
            .catch(() => {
                if (!cancelled) {
                    setFooterPreview(buildEmptyFooterPreview());
                }
            });

        return () => {
            cancelled = true;
        };
    }, [isOpen]);

    return footerPreview;
}
